import { httpClient } from "./httpClient";

const base = "/api/referentes";

export const listar      = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return httpClient.get(`${base}${qs ? `?${qs}` : ""}`);
};
export const listarActivos = () => httpClient.get(`${base}/activos`);
export const buscar = (term = "", filters = {}) => {
  const params = new URLSearchParams();
  const normalizedTerm = (term || "").trim();
  if (normalizedTerm) params.set("term", normalizedTerm);
  if (filters?.tipo) params.set("tipo", String(filters.tipo).trim().toLowerCase());
  if (filters?.centro_id) params.set("centro_id", String(filters.centro_id));
  const query = params.toString();
  return httpClient.get(`${base}/buscar${query ? `?${query}` : ""}`);
};
export const obtener = (id) => httpClient.get(`${base}/${id}`);
export const crear   = (data) => httpClient.post(base, data);
export const editar  = (id, data) => httpClient.put(`${base}/${id}`, data);
export const toggle  = (id) => httpClient.patch(`${base}/${id}/toggle`);
export const ranking = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return httpClient.get(`${base}/ranking${qs ? `?${qs}` : ""}`);
};
export const obtenerBonificaciones  = (id) => httpClient.get(`${base}/${id}/bonificaciones`);
export const listarCursosComision   = (id) => httpClient.get(`${base}/${id}/cursos-comision`);
export const crearCursoComision     = (id, data) => httpClient.post(`${base}/${id}/cursos-comision`, data);
export const eliminarCursoComision  = (id, cursoId) => httpClient.del(`${base}/${id}/cursos-comision/${cursoId}`);

export const exportarRanking = async (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  const token = typeof localStorage !== "undefined" ? localStorage.getItem("token") : null;
  const rawBase = process.env.REACT_APP_API_URL || "";
  const url = `${rawBase}/api/referentes/ranking/exportar${qs ? `?${qs}` : ""}`;
  const res = await fetch(url, {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  if (!res.ok) {
    const data = await res.json().catch(() => ({}));
    throw new Error(data.message || "Error al exportar");
  }
  return res.blob();
};

const referentesService = {
  listar, listarActivos, buscar, obtener, obtenerBonificaciones, crear, editar, toggle,
  ranking, exportarRanking,
  listarCursosComision, crearCursoComision, eliminarCursoComision,
};

export default referentesService;
